import { getLocale } from "../runtime";

const da_lowestpricelast30days = /** @type {(inputs: {price: NonNullable<unknown>}) => string} */ (inputs) => {
	return `Laveste pris de sidste 30 dage: ${inputs.price}`
};

const en_lowestpricelast30days = /** @type {(inputs: {price: NonNullable<unknown>}) => string} */ (inputs) => {
	return `Lowest price in the last 30 days: ${inputs.price}`
};

const es_lowestpricelast30days = /** @type {(inputs: {price: NonNullable<unknown>}) => string} */ (inputs) => {
	return `Precio más bajo en los últimos 30 días: ${inputs.price}`
};

const fi_lowestpricelast30days = /** @type {(inputs: {price: NonNullable<unknown>}) => string} */ (inputs) => {
	return `Alin hinta viimeisen 30 päivän aikana: ${inputs.price}`
};

const nb_lowestpricelast30days = /** @type {(inputs: {price: NonNullable<unknown>}) => string} */ (inputs) => {
	return `Laveste pris de siste 30 dagene: ${inputs.price}`
};

const sv_lowestpricelast30days = /** @type {(inputs: {price: NonNullable<unknown>}) => string} */ (inputs) => {
	return `Lägsta priset de senaste 30 dagarna: ${inputs.price}`
};

const lowestpricelast30days = /** @type {(inputs: {price: NonNullable<unknown>}, options?: {locale?: string}) => string} */ (inputs = {}, options = {}) => {
	const locale = options.locale ?? getLocale();
	if (locale === "da") return da_lowestpricelast30days(inputs)
	if (locale === "en") return en_lowestpricelast30days(inputs)
	if (locale === "es") return es_lowestpricelast30days(inputs)
	if (locale === "fi") return fi_lowestpricelast30days(inputs)
	if (locale === "nb") return nb_lowestpricelast30days(inputs)
	if (locale === "sv") return sv_lowestpricelast30days(inputs)
	return "lowestPriceLast30Days";
};

export { lowestpricelast30days as "lowestPriceLast30Days" };